import React from 'react';
import { Trans } from '@lingui/macro';

import { Container, Section, Grid, Typography, Column } from 'components';

import AppStore from 'assets/images/black-friday/ratings/app_store.jpg';
import AppStoreRating from 'assets/images/black-friday/ratings/app_store_rating.jpg';
import GooglePlay from 'assets/images/black-friday/ratings/google_play.jpg';
import GooglePlayRating from 'assets/images/black-friday/ratings/google_play_rating.jpg';

import Wired from 'assets/images/black-friday/ratings/wired.jpg';
import NYTimes from 'assets/images/black-friday/ratings/ny_times.jpg';
import Variety from 'assets/images/black-friday/ratings/variety.jpg';

export const Ratings = () => {
    return (
        <Section background="white">
            <Container>
                <Grid alignCenter>
                    <Column cols={3} mobile={2} tablet={6}>
                        <div>
                            <img width="100%" src={AppStore} alt="" />
                        </div>

                        <Typography
                            variant="bodyl"
                            spaceBottom="large"
                            color="baseGray"
                            align="center"
                        >
                            <Trans>App Store</Trans>
                        </Typography>
                    </Column>
                    <Column cols={3} mobile={2} tablet={6}>
                        <div>
                            <img width="100%" src={AppStoreRating} alt="" />
                        </div>

                        <Typography
                            variant="bodyl"
                            spaceBottom="large"
                            color="baseGray"
                            align="center"
                        >
                            <Trans>App Store rating </Trans>
                        </Typography>
                    </Column>
                    <Column cols={3} mobile={2} tablet={6}>
                        <div>
                            <img width="100%" src={GooglePlay} alt="" />
                        </div>

                        <Typography
                            variant="bodyl"
                            spaceBottom="large"
                            color="baseGray"
                            align="center"
                        >
                            <Trans>Google Play </Trans>
                        </Typography>
                    </Column>
                    <Column cols={3} mobile={2} tablet={6}>
                        <div>
                            <img width="100%" src={GooglePlayRating} alt="" />
                        </div>

                        <Typography
                            variant="bodyl"
                            spaceBottom="large"
                            color="baseGray"
                            align="center"
                        >
                            <Trans>Google Play rating </Trans>
                        </Typography>
                    </Column>
                </Grid>
            </Container>
        </Section>
    );
};

export const Magazines = () => {
    return (
        <Section background="white">
            <Container>
                <Grid alignCenter>
                    <Column cols={4}>
                        <div>
                            <img width="100%" src={NYTimes} alt="" />
                        </div>

                        <Typography
                            variant="bodyl"
                            spaceBottom="large"
                            color="baseGray"
                            align="center"
                        >
                            <Trans>
                                “Its extensive lessons on technique and music
                                theory make it clear that Yousician is no toy.”
                            </Trans>
                        </Typography>
                    </Column>
                    <Column cols={4}>
                        <div>
                            <img width="100%" src={Wired} alt="" />
                        </div>

                        <Typography
                            variant="bodyl"
                            spaceBottom="large"
                            color="baseGray"
                            align="center"
                        >
                            <Trans>
                                “It’s the closest you’ll get to a
                                real-instrument version of Guitar Hero.”
                            </Trans>
                        </Typography>
                    </Column>
                    <Column cols={4}>
                        <div>
                            <img width="100%" src={Variety} alt="" />
                        </div>

                        <Typography
                            variant="bodyl"
                            spaceBottom="large"
                            color="baseGray"
                            align="center"
                        >
                            <Trans>
                                “Yousician, which provides interactive learning
                                for guitar, bass, ukulele, piano and voice,
                                currently reigns as the No. 1 app for music
                                instruction.”
                            </Trans>
                        </Typography>
                    </Column>
                </Grid>
            </Container>
        </Section>
    );
};
